/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HousingOrg } from '../models/HousingOrg';
import type { HousingOrgDetailDto } from '../models/HousingOrgDetailDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HousingOrgService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all housing orgs in the DB.
     * @param sysOrgGuid
     * @returns HousingOrg OK
     * @throws ApiError
     */
    public getAllHousingOrgs(
        sysOrgGuid: string,
    ): CancelablePromise<Array<HousingOrg>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingOrg/{sysOrgGuid}/GetAllHousingOrgs',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
        });
    }
    /**
     * Update a housing org by its guid.
     * @param orgGuid The guid of the org.
     * @param requestBody The updated org.
     * @returns HousingOrg OK
     * @throws ApiError
     */
    public updateHousingOrg(
        orgGuid: string,
        requestBody?: HousingOrg,
    ): CancelablePromise<HousingOrg> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingOrg/{orgGuid}/UpdateHousingOrg',
            path: {
                'orgGuid': orgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new org.
     * @param sysOrgGuid
     * @param entityDefinitionGuid
     * @param requestBody
     * @returns HousingOrg OK
     * @throws ApiError
     */
    public createHousingOrg(
        sysOrgGuid: string,
        entityDefinitionGuid?: string,
        requestBody?: HousingOrg,
    ): CancelablePromise<HousingOrg> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingOrg/{sysOrgGuid}/CreateHousingOrg',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            query: {
                'entityDefinitionGuid': entityDefinitionGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get detailed info of a housing org, including its members and application status counts.
     * @param housingOrgGuid
     * @returns HousingOrgDetailDto OK
     * @throws ApiError
     */
    public getHousingOrgDetail(
        housingOrgGuid: string,
    ): CancelablePromise<HousingOrgDetailDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingOrg/{housingOrgGuid}/GetHousingOrgDetail',
            path: {
                'housingOrgGuid': housingOrgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
